module.exports = __webpack_public_path__ + "media/images/illustrations/illustration-6-c92371b6e2305842476c2443902d30dd.png";